import { render, staticRenderFns } from "./WordCutter.vue?vue&type=template&id=d77a8d02&scoped=true&"
import script from "./WordCutter.vue?vue&type=script&lang=js&"
export * from "./WordCutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77a8d02",
  null
  
)

export default component.exports